import CookieMatching from './cookieMatching'

CookieMatching(FollozeState.initialState.cookie_matching)
